/**
 * Get the messageTracking object for a ChatRequest. Omit values if they are undefined.
 */
export const getMessageTracking = ({
  template,
  isSavedPrompt
}) => {
  if (!template && isSavedPrompt === undefined) {
    return {};
  }
  return {
    messageTracking: Object.assign({}, (template === null || template === void 0 ? void 0 : template.id) && {
      templateId: template.id
    }, isSavedPrompt !== undefined && {
      isSavedPrompt
    })
  };
};